import type { FC } from 'react'

import { Checkbox, Textarea } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'
import { useIsAdmin } from '@/hooks/access'

import { AdminOverwriteUserId } from './AdminOverwriteUserId'

import { usePolicyFilters } from '../../Policy.context'

export const AdvancedSettings: FC = () => {
  const [, setIsVatIncluded] = usePolicyFilters().isVatIncluded
  const isAdmin = useIsAdmin()

  return (
    <>
      <h2>
        <Translation id="Advanced settings" />
      </h2>

      <AdminOverwriteUserId />

      <Field name="messageToEmployee">
        {({ field, meta }: FieldProps) => (
          <Textarea
            label={<Translation id="Message to employee" />}
            isFullWidth
            id="messageToEmployee"
            error={meta.error}
            touched={meta.touched}
            {...field}
          />
        )}
      </Field>

      <Field name="stepMainDescription">
        {({ field, meta }: FieldProps) => (
          <Textarea
            marginTop={16}
            label={<Translation id="Step main description" />}
            isFullWidth
            id="stepMainDescription"
            error={meta.error}
            touched={meta.touched}
            {...field}
          />
        )}
      </Field>

      <Field name="stepAccessoriesDescription">
        {({ field, meta }: FieldProps) => (
          <Textarea
            marginTop={16}
            label={<Translation id="Step accessories description" />}
            isFullWidth
            id="stepAccessoriesDescription"
            error={meta.error}
            touched={meta.touched}
            {...field}
          />
        )}
      </Field>

      <Field name="hasVat">
        {({ field }: FieldProps) => (
          <Checkbox
            capitalizeLabel
            id="hasVat"
            label={<Translation id="Include VAT in price" />}
            marginBottom={16}
            marginTop={16}
            checked={field.value}
            onFieldChange={() => setIsVatIncluded(!field.value)}
            {...field}
          />
        )}
      </Field>

      {isAdmin && (
        <Field name="isAdminRestricted">
          {({ field, form }: FieldProps) => (
            <Checkbox
              capitalizeLabel
              id="isAdminRestricted"
              label={<Translation id="Is admin restricted" />}
              checked={field.value}
              {...field}
              onChange={e => {
                field.onChange(e)
                form.setFieldValue('isManagerAccessible', false)
              }}
            />
          )}
        </Field>
      )}

      <Field name="isManagerAccessible">
        {({ field, form }: FieldProps) => (
          <Checkbox
            capitalizeLabel
            id="isManagerAccessible"
            label={<Translation id="Is manager accessible" />}
            checked={field.value}
            isDisabled={form.values.isAdminRestricted}
            {...field}
          />
        )}
      </Field>

      <Field name="isRelationsIgnored">
        {({ field }: FieldProps) => (
          <Checkbox
            capitalizeLabel
            id="isRelationsIgnored"
            label={<Translation id="Ignore relations" />}
            checked={field.value}
            marginBottom={16}
            {...field}
          />
        )}
      </Field>
    </>
  )
}
